export default "__VITE_ASSET__B0nxoWv1__"